// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CellList-module__ui-CellList--dCySN {
  width: 100%;
  box-sizing: border-box;
}

.CellList-module__ui-CellList--dCySN > .CellList-module__content--IZRqs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
  width: 100%;
  max-width: none;
  overflow: visible;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: normal;
  text-overflow: clip;
  white-space: normal;
}

.CellList-module__cell-list-title--F4C96 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2px 6px;
  padding-bottom: 2px;
  color: #1a1a1a;
  font-size: 0.875rem; /* 14px */
  font-weight: 700;
  line-height: normal;
}

.CellList-module__cell-list-title--F4C96 > :last-child:not(:first-child) {
  padding-bottom: 1px;
  color: #777777;
  font-size: 0.6875rem; /* 11px */
  font-weight: 400;
}

.CellList-module__ui-CellList-Item--E8hcD {
  position: relative;
  display: flex;
  min-width: 0;
  height: 82px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 7px 8px 7px 7px;
  border-top: 1px solid #c9c3ba;
  border-right: 1px solid #d8d2c9;
  border-bottom: 1px solid #c9c3ba;
}

.CellList-module__ui-CellList-Item--E8hcD:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 100%;
  right: -1px;
  width: 1px;
  height: 14px;
  background-color: #d8d2c9;
}

.CellList-module__ui-CellList-Item--E8hcD:last-child {
  padding-right: 7px;
  border-right: 0;
  background-color: #fff4df;
}

.CellList-module__headline--xRvRV,
.CellList-module__title--BvCs8,
.CellList-module__content--IZRqs {
  display: block;
  max-width: 100%;
  box-sizing: border-box;
}

.CellList-module__headline--xRvRV {
  color: #a05a27;
  font-size: 1.1875rem; /* 19px */
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}

.CellList-module__ui-CellList-Item--E8hcD:last-child .CellList-module__headline--xRvRV {
  color: #ff9800;
}

.CellList-module__title--BvCs8 {
  display: -webkit-box;
  width: 100%;
  overflow: hidden;
  color: #1a1a1a;
  font-size: 0.75rem; /* 12px */
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.CellList-module__content--IZRqs {
  overflow: hidden;
  color: #888888;
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/CellList/CellList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".ui-CellList {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ui-CellList > .content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));\n  width: 100%;\n  max-width: none;\n  overflow: visible;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: normal;\n  text-overflow: clip;\n  white-space: normal;\n}\n\n.cell-list-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 2px 6px;\n  padding-bottom: 2px;\n  color: #1a1a1a;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 700;\n  line-height: normal;\n}\n\n.cell-list-title > :last-child:not(:first-child) {\n  padding-bottom: 1px;\n  color: #777777;\n  font-size: 0.6875rem; /* 11px */\n  font-weight: 400;\n}\n\n.ui-CellList-Item {\n  position: relative;\n  display: flex;\n  min-width: 0;\n  height: 82px;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 7px 8px 7px 7px;\n  border-top: 1px solid #c9c3ba;\n  border-right: 1px solid #d8d2c9;\n  border-bottom: 1px solid #c9c3ba;\n}\n\n.ui-CellList-Item:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  right: -1px;\n  width: 1px;\n  height: 14px;\n  background-color: #d8d2c9;\n}\n\n.ui-CellList-Item:last-child {\n  padding-right: 7px;\n  border-right: 0;\n  background-color: #fff4df;\n}\n\n.headline,\n.title,\n.content {\n  display: block;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.headline {\n  color: #a05a27;\n  font-size: 1.1875rem; /* 19px */\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.ui-CellList-Item:last-child .headline {\n  color: #ff9800;\n}\n\n.title {\n  display: -webkit-box;\n  width: 100%;\n  overflow: hidden;\n  color: #1a1a1a;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 700;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.content {\n  overflow: hidden;\n  color: #888888;\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: normal;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-CellList": `CellList-module__ui-CellList--dCySN`,
	"content": `CellList-module__content--IZRqs`,
	"cell-list-title": `CellList-module__cell-list-title--F4C96`,
	"ui-CellList-Item": `CellList-module__ui-CellList-Item--E8hcD`,
	"headline": `CellList-module__headline--xRvRV`,
	"title": `CellList-module__title--BvCs8`
};
export default ___CSS_LOADER_EXPORT___;
